export default __webpack_public_path__ + "static/media/writersIcon.2cffd62b.png";